import {AUDIT_TEMPLATE_FIELDS_GQL, AUDIT_RUN_FIELDS_GQL, AUDIT_ASSIGNMENT_FIELDS_GQL} from "./queries";

export const onCreateAuditTemplate = /* GraphQL */ `
  subscription onCreateAuditTemplate($workspaceId: String!) {
    onCreateAuditTemplate(workspaceId: $workspaceId) { ${AUDIT_TEMPLATE_FIELDS_GQL} }
  }
`;

export const onUpdateAuditTemplate = /* GraphQL */ `
  subscription onUpdateAuditTemplate($workspaceId: String!) {
    onUpdateAuditTemplate(workspaceId: $workspaceId) { ${AUDIT_TEMPLATE_FIELDS_GQL} }
  }
`;

export const onDeleteAuditTemplate = /* GraphQL */ `
  subscription onDeleteAuditTemplate($workspaceId: String!) {
    onDeleteAuditTemplate(workspaceId: $workspaceId) { ${AUDIT_TEMPLATE_FIELDS_GQL} }
  }
`;

export const onAuditRunMutated = /* GraphQL */ `
  subscription onAuditRunMutated($ownerId: String!, $workspaceId: String!) {
    onAuditRunMutated(ownerId: $ownerId, workspaceId: $workspaceId) { ${AUDIT_RUN_FIELDS_GQL} }
  }
`;

export const onCreateAuditAssignment = /* GraphQL */ `
  subscription onCreateAuditAssignment($workspaceId: String!) {
    onCreateAuditAssignment(workspaceId: $workspaceId) { ${AUDIT_ASSIGNMENT_FIELDS_GQL} }
  }
`;

export const onUpdateAuditAssignment = /* GraphQL */ `
  subscription onUpdateAuditAssignment($workspaceId: String!) {
    onUpdateAuditAssignment(workspaceId: $workspaceId) { ${AUDIT_ASSIGNMENT_FIELDS_GQL} }
  }
`;

export const onDeleteAuditAssignment = /* GraphQL */ `
  subscription onDeleteAuditAssignment($workspaceId: String!) {
    onDeleteAuditAssignment(workspaceId: $workspaceId) { ${AUDIT_ASSIGNMENT_FIELDS_GQL} }
  }
`;
